/**
 * Legal entity — Hartenstein GmbH (NODEMOS)
 */
export const legalEntity = {
  tradeName: 'NODEMOS',
  legalName: 'Hartenstein GmbH',
  managingDirector: 'Nikolaus Hartenstein',
  street: 'F. Moser Gasse 11',
  zip: '2353',
  city: 'Guntramsdorf',
  country: 'Österreich',
  address: 'F. Moser Gasse 11, 2353 Guntramsdorf, Österreich',
  email: 'privacy@nodemos.at',
  phone: '+43 664 4536578',
  website: 'https://nodemos.at',
  uid: 'ATU79057556',
  companyRegister: 'FN 584633 f',
  trade: 'Softwareentwicklung, IT-Dienstleistungen, Software Product Design',
  tradeAuthority: 'Bezirkshauptmannschaft Mödling',
  contentResponsible: 'Nikolaus Hartenstein',
}

export const impressum = {
  title: 'Impressum',
  lead: 'Angaben gemäß § 5 E-Commerce-Gesetz (ECG) und § 25 Mediengesetz (MedienG).',
  updated: 'Juli 2026',
  sections: [
    {
      heading: 'Medieninhaber und Herausgeber',
      paragraphs: [
        `${legalEntity.legalName}`,
        `${legalEntity.tradeName} — eine Marke der ${legalEntity.legalName}`,
        legalEntity.address,
      ],
    },
    {
      heading: 'Geschäftsführung',
      paragraphs: [`Geschäftsführer: ${legalEntity.managingDirector}`],
    },
    {
      heading: 'Kontakt',
      paragraphs: [
        `Telefon: ${legalEntity.phone}`,
        `E-Mail: ${legalEntity.email}`,
        `Website: ${legalEntity.website}`,
      ],
    },
    {
      heading: 'Unternehmensgegenstand',
      paragraphs: [legalEntity.trade],
    },
    {
      heading: 'Firmenbuch',
      paragraphs: [`Firmenbuchnummer: ${legalEntity.companyRegister}`],
    },
    {
      heading: 'UID-Nummer',
      paragraphs: [`Umsatzsteuer-Identifikationsnummer: ${legalEntity.uid}`],
    },
    {
      heading: 'Gewerberechtliche Vorschrift',
      paragraphs: [
        'Gewerbeordnung (GewO), E-Commerce-Gesetz (ECG).',
        `Zuständige Behörde: ${legalEntity.tradeAuthority}`,
      ],
    },
    {
      heading: 'Verantwortlich für den Inhalt',
      paragraphs: [
        `${legalEntity.contentResponsible}, ${legalEntity.address}`,
      ],
    },
    {
      heading: 'Haftungsausschluss',
      paragraphs: [
        'Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.',
        'Als Diensteanbieter sind wir gemäß § 7 Abs. 1 ECG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 ECG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
      ],
    },
    {
      heading: 'Urheberrecht',
      paragraphs: [
        'Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',
      ],
    },
  ],
}

export const datenschutz = {
  title: 'Datenschutzerklärung',
  lead: 'Informationen zur Verarbeitung personenbezogener Daten gemäß der Datenschutz-Grundverordnung (DSGVO) und dem österreichischen Datenschutzgesetz (DSG).',
  updated: 'Juli 2026',
  sections: [
    {
      heading: '1. Verantwortlicher',
      paragraphs: [
        'Verantwortlicher im Sinne von Art. 4 Z 7 DSGVO:',
        `${legalEntity.legalName}`,
        `${legalEntity.tradeName} — ${legalEntity.legalName}`,
        legalEntity.address,
        `Telefon: ${legalEntity.phone}`,
        `E-Mail: ${legalEntity.email}`,
        `UID: ${legalEntity.uid}`,
      ],
    },
    {
      heading: '2. Allgemeines zur Datenverarbeitung',
      paragraphs: [
        'Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Website, zur Bearbeitung Ihrer Anfragen und zur Erfüllung unserer vertraglichen bzw. vorvertraglichen Pflichten erforderlich ist.',
        'Die Verarbeitung erfolgt in der Regel auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertrag bzw. vorvertragliche Maßnahmen), Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am Betrieb und an der Sicherheit dieser Website) oder auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO, sofern Sie diese ausdrücklich erteilt haben.',
        'Daten werden bevorzugt in der Europäischen Union verarbeitet. Eine Datenübermittlung in Drittländer erfolgt nur unter den in Abschnitt 7 genannten Voraussetzungen.',
      ],
    },
    {
      heading: '3. Kontakt-, Pitch- und Produktkonfigurations-Anfragen',
      paragraphs: [
        'Wenn Sie uns über Kontaktformulare, Pitch-Formulare, die interaktive Produktkonfiguration (Onboarding) oder per E-Mail kontaktieren, verarbeiten wir die von Ihnen übermittelten Daten (z. B. Name, E-Mail-Adresse, Unternehmen, Inhalt Ihrer Nachricht, technische Angaben zu Ihrem Vorhaben sowie Konfigurationsdaten aus dem Onboarding-Prozess).',
        `Mit dem Absenden Ihrer Anfrage bestätigen Sie, dass Sie diese Datenschutzerklärung zur Kenntnis genommen haben und einverstanden sind, dass die ${legalEntity.legalName} (${legalEntity.tradeName}) die von Ihnen eingegebenen Informationen speichert und verarbeitet.`,
      ],
      list: [
        'Speicherdauer: Ihre Daten werden standardmäßig für 90 Tage ab Eingang gespeichert, sofern keine längere Aufbewahrung erforderlich ist (z. B. bei Aufnahme einer Geschäftsbeziehung oder gesetzlichen Aufbewahrungspflichten).',
        'Lokale Zwischenspeicherung: Die Produktkonfiguration kann während Ihrer Browsersitzung in sessionStorage gespeichert werden, bis Sie die Anfrage absenden oder die Sitzung beenden. Diese Daten werden nicht an uns übermittelt, solange Sie das Formular nicht absenden.',
        'Verwendungszweck: Die Daten werden verwendet, um Ihre Anfrage zu bearbeiten, Sie als Kunden bzw. Interessenten zu betreuen und unsere Dienstleistungen für Sie zu erbringen.',
        'Löschung: Sie können die Löschung Ihrer gespeicherten Daten jederzeit verlangen. Senden Sie dazu eine E-Mail an die im Abschnitt „Verantwortlicher“ genannte Adresse.',
      ],
    },
    {
      heading: '4. Bereitstellung der Website und Server-Logfiles',
      paragraphs: [
        'Beim Aufruf unserer Website werden durch den Hosting-Anbieter automatisch Informationen erfasst und in Server-Logfiles gespeichert (z. B. IP-Adresse, Datum und Uhrzeit des Abrufs, Browsertyp, Betriebssystem).',
        'Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technischen Bereitstellung und Sicherheit der Website). Die Logdaten werden gelöscht, sobald sie für den Zweck der Erhebung nicht mehr erforderlich sind.',
      ],
    },
    {
      heading: '5. Cookies und lokale Speicherung',
      paragraphs: [
        'Diese Website verwendet nur technisch notwendige Mechanismen, soweit für den Betrieb erforderlich (z. B. sessionStorage für Formular- und Onboarding-Zwischenspeicherung, sessionStorage für den Zugangsschutz in Produktionsbuilds).',
        'Es werden keine Marketing- oder Tracking-Cookies zu Analyse- oder Werbezwecken eingesetzt, sofern nicht gesondert angegeben und von Ihnen eingewilligt.',
      ],
    },
    {
      heading: '6. Weitergabe von Daten',
      paragraphs: [
        'Eine Übermittlung Ihrer personenbezogenen Daten an Dritte erfolgt nur, wenn dies zur Vertragserfüllung notwendig ist, wir gesetzlich dazu verpflichtet sind, oder Sie eingewilligt haben.',
        'Auftragsverarbeiter (z. B. Hosting-Provider) werden vertraglich gemäß Art. 28 DSGVO verpflichtet, Ihre Daten nur nach unseren Weisungen und unter Einhaltung der DSGVO zu verarbeiten.',
      ],
    },
    {
      heading: '7. Datenübermittlung in Drittländer',
      paragraphs: [
        'Eine Übermittlung personenbezogener Daten in Staaten außerhalb des Europäischen Wirtschaftsraums (EWR) erfolgt nur, wenn die Voraussetzungen der Art. 44 ff. DSGVO erfüllt sind (z. B. Angemessenheitsbeschluss oder Standardvertragsklauseln).',
      ],
    },
    {
      heading: '8. Ihre Rechte',
      paragraphs: ['Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:'],
      list: [
        'Recht auf Auskunft (Art. 15 DSGVO)',
        'Recht auf Berichtigung (Art. 16 DSGVO)',
        'Recht auf Löschung (Art. 17 DSGVO)',
        'Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)',
        'Recht auf Datenübertragbarkeit (Art. 20 DSGVO)',
        'Recht auf Widerspruch (Art. 21 DSGVO)',
        'Recht auf Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO) mit Wirkung für die Zukunft',
      ],
      afterList: [
        'Zur Ausübung Ihrer Rechte genügt eine Nachricht an die im Abschnitt „Verantwortlicher“ genannte E-Mail-Adresse oder telefonisch unter der angegebenen Nummer.',
        'Sie haben zudem das Recht, Beschwerde bei der österreichischen Datenschutzbehörde einzulegen:',
        'Österreichische Datenschutzbehörde, Barichgasse 40–42, 1030 Wien, www.dsb.gv.at',
      ],
    },
    {
      heading: '9. Datensicherheit',
      paragraphs: [
        'Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen. Die Maßnahmen werden dem Stand der Technik entsprechend fortlaufend angepasst.',
      ],
    },
    {
      heading: '10. Änderungen dieser Datenschutzerklärung',
      paragraphs: [
        'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder Änderungen unserer Leistungen abbildet. Für Ihren erneuten Besuch gilt dann die jeweils aktuelle Fassung.',
        'Stand: Juli 2026',
      ],
    },
  ],
}

/** Short notice for form consent checkboxes */
export const formDataNotice =
  'Mit dem Absenden bestätige ich, dass die Hartenstein GmbH (NODEMOS) die eingegebenen Informationen für 90 Tage speichert, um meine Anfrage zu bearbeiten und mich als Kunden zu betreuen. Ich habe die Datenschutzerklärung gelesen und kann die Löschung meiner Daten jederzeit verlangen.'

export const legalLinks = [
  { label: 'Impressum', to: '/impressum' },
  { label: 'Datenschutz', to: '/datenschutz' },
]